<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/reportNest/downlineOperator")
          i.fa.fa-users
          span.ml-1 {{ $tc("ui.downline_operator") }}
      b-breadcrumb-item(v-if="!isSelf" @click="onRedirect($store.getters.accountId, true)")
        span {{ $store.getters.accountId }}
      b-breadcrumb-item(
        v-for="(item,index) in breadcrumbList"
        :key="index"
        :text="item.account_id.toUpperCase()"
        :class="{ active: index==breadcrumbList.length-1 }"
        @click="onRedirect(item.account_id)"
      )
        span {{ item.account_id }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 40%;")
                  thead
                    tr
                      th.sticky-position(width="6%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.text-center.sticky-position(width="15%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="downlineList.length == 0 && !isSelf")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-if="isSelf")
                      td
                        span(title="1") 1
                      td
                        span.font-weight-bold(:title="$store.getters.accountId")
                          b-link.clickable(href="javascript:void(0);" @click="onRedirect($store.getters.accountId)") {{ $store.getters.accountId }}
                      td.actions
                        span
                          a.fa.fa-chart-line.text-warning(href="javascript:void(0)" @click="redirectToWL($store.getters.accountId)" :title="$t('ui.daily_winlose')")
                    tr(v-for="(item, index) in downlineList" v-if="!isSelf")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span.font-weight-bold(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="onRedirect(item.account_id)") {{ item.account_id }}
                      td.actions
                        span
                          a.fa.fa-chart-bar.text-primary(href="javascript:void(0)" @click="redirectToDS(item.account_id)" :title="$t('ui.daily_statement')")
                        span
                          a.fa.fa-chart-line.text-warning(href="javascript:void(0)" @click="redirectToWL(item.account_id)" :title="$t('ui.daily_winlose')")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
  },
  data: () => ({
    loading: false,
    downlineList: [],
    breadcrumbList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortType: "asc",
    filterBy: "account_id",
    isSelf: true,
    curOperatorId: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    //this.getDownlineList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDownlineList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onRedirect(accountId, isSelf) {
      this.curOperatorId = accountId;
      if (isSelf == true)
        this.getDownlineList(isSelf);
      else
        this.getDownlineList();
    },
    redirectToDS: function(accountId) {
      var json = {
        target_account_id: accountId,
        start_date: this.$moment(new Date).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date).format('YYYY-MM-DD')
      };

      this.$store.dispatch("user/setDailyStatementNestParam", json);
      this.$router.push("/reportNest/dailyStatementNest");
    },
    redirectToWL: function(accountId) {
      var json = {
        target_account_id: accountId,
        search_id: '',
        start_date: this.$moment(new Date).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date).format('YYYY-MM-DD'),
        // start_date: '2020-09-01',
        // end_date: '2020-09-15'
      };
      this.$store.dispatch("user/setWinLoseNestParam", json);
      this.$router.push("/reportNest/dailyWinLoseNest");
    },
    getDownlineList: function(isSelf) {
      let url = config.accountNestListDownlineUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.curOperatorId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.isSelf = isSelf ? true : false;

                this.downlineList = response.data.ds.downline;
                var list = response.data.ds.breadcrumb.length > 0 ? response.data.ds.breadcrumb.sort().reverse() : response.data.ds.breadcrumb;
                var currentId = this.$store.getters.accountId;
                this.breadcrumbList = list.filter(function(obj) {
                  return obj.account_id != currentId;
                });
                this.totalRow = this.downlineList.length > 0 ? this.downlineList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDownlineList();
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDownlineList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>